<div class="more-info-content">
  <img
    class="rb-safe-image"
    src="assets\images\more-info-rb-icon.svg"
    alt="rb-safe-medium"
  />
  <div class="sub-heading">{{ sdfCardLabels.moreInfoPage.littleInfo }}.</div>

  <p class="paragraph">{{ sdfCardLabels.moreInfoPage.photoId }}.</p>

  <p class="paragraph">{{ sdfCardLabels.moreInfoPage.storeInfo }}.</p>
</div>

<div class="mg-step-actions-row">
  <!-- <button class="button-style" color="primary"
        mat-raised-button
        type="submit"
        (click)="nextPage()">Continue</button> -->
  <app-submit-button
    (buttonClick)="nextPage()"
    [buttonText]="sdfCardLabels.common.continue"
  ></app-submit-button>
</div>
